import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { css } from "styled-components";

customerSelectorToolbarStyles.wideCreateNewAddressButton = {
    ...customerSelectorToolbarStyles.wideCreateNewAddressButton,
    variant: "secondary",
    css: css`
        margin-left: 10px;
    `,
};
